import React from 'react'
import '../Component/css/Clavr.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/clavr/header.webp'
import header2 from '../assets/product/clavr/header2.webp'
import header3 from '../assets/product/clavr/header3.webp'
import header4 from '../assets/product/clavr/header4.webp'
import clavrbg from '../assets/product/clavr/clavrbg.webp'

// video
import clavrVideo from '../assets/product/clavr/clavr.mp4'


const Clavr = () => {

  const navigate = useNavigate()

  return (
    <div className="about">
    <section className="about-section sec-padding">
      <div className="container">
        <h1 className='projecth1'>Product.</h1>
        <div className="project-row">
        <div className='clavr-project'>

{/* IMAGE BACKGROUND */}
        <img src={clavrbg} alt="background" className='treebg' />

{/* TIMELINE */}
<div className="clavr-timeline">
        <ul className='clavr-ul'>
          <li className='clavr-li'><div className="li">Challenge</div><span>A redesign of Clavr's web page to connect better with its users</span></li>
          {/* <li className='clavr-li'><div className="li">Role</div><span> Product Design and UX Research</span></li> */}
          <li className='clavr-li'><div className="li">Sector</div><span>Productivity | Business | Photo & Video</span></li>
          <li className='clavr-li'><div className="li">Timeline</div><span>5 Month</span></li>
        </ul>
      </div>

{/* HEADER 1 */}

            <div className="clavr-header-body">
              <div className="clavr-header-detail">
                <div className="clavr-header-text-one">
                  <div className="clavr-main-text-one">
                    <h3>About</h3>
                    <div className="clavr-icon">
                    <i class="fas fa-laptop"></i>
                    <i class="fas fa-tablet"></i>
                    <i class="fas fa-desktop"></i>
                    </div>
                  </div>  
                    <p>
                    Clavr is a video conference tool that supports hybrid professionals. Clavr offers video meetings, chats, virtual notes, and resources to help companies have an engaging video meeting experience. The project provides an aesthetic use of black and tortoise blue in the user interface. The prototype is avaliable on <strong><a href="https://www.figma.com/proto/2tRi2SostPcVbx3yWqegmE/CLAVR?page-id=0%3A1&node-id=310%3A200&viewport=241%2C48%2C0.2&scaling=min-zoom&starting-point-node-id=310%3A200" target="_blank" rel="noopener noreferrer">Figma</a></strong>
                    </p>             
                </div>
          </div>
        </div>
        <div className="clavr-header-image-one">
                <img src={header} alt="Clavr Header" />
            </div>
  {/* END */}

  {/* GOAL */}

            <div className="clavr-goal">
              <div className="clavr-goal-text">
                <h3>Goal</h3>
                <p>The aim was to design a web page that gives a sense of professionalism, allowing potential users to associate Clavr as a tool for communicating professionally in a work environment.</p>
              </div>
            </div>

            <div className="clavr-goal-image">
                <img src={header2} alt="Clavr Goal" />
              </div>
{/* DESIGN PROCESS */}
            <div className="clavr-detail">
              <div className="clavr-detail-text">
                <h3>Design Process</h3>
                <p>To start, my team and I researched the user's behaviour toward similar products to understand how the user thinks and feels.  Later, we created a user flow and low fidelity wireframe to guide our decision-making process. Finally, I designed the high fidelity wireframe and moved on to the next phase of the design.</p>
              </div>
            </div>
            <div className="clavr-detail-image">
                <img src={header4} alt="Clavr Detail" />
              </div>
{/* FEATURE */}
            <div className="clavr-detail">
              <div className="clavr-detail-text">
                <div className="clavr-detail-text-one">
                <h3>Color</h3>
                <p>Compared to other professional websites that use the colour white to create a professional user experience. I decided to go with black to create a bold and aesthetic experience.  In addition, the accent colour was gotten from the logo for users to get familiar with Clavr's brand colour. The colour gives Clavr a sense of bold professionalism which was exactly what the clients wanted. I worked with <strong><a href="https://www.linkedin.com/in/mikexpress/" target="_blank"  rel="noopener noreferrer">Micheal Ezeoda</a></strong> on the choice of color</p>
                </div>
              </div>
            </div>
            <div className="clavr-detail-image">
                <img src={header3} alt="Clavr Detail" />
              </div>
{/* VIDEO */}
            <div className="tree-detail-image">
                <video src={clavrVideo} controls></video>
            </div>

{/* ANIMATION */}
        <h2 className='clavr-h2'><span>Thanks for scrolling</span></h2>

        <p className='clavr-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
        </div>

{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                      <p>Go back to Portfolio</p> 
                      <div className="icon">
                          <i class="fas fa-angle-right"></i>
                          <i class="fas fa-angle-right"></i>
                      </div>
                    </div>
        </div>
      </div>
    </section>
  </div>
  )
}

export default Clavr